import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from '../../../../../src/app/services/transfer-http/transfer-http.service';
import { HrTravelBagDefaults } from '../../../../../src/models';
import { PermissionsService } from '../../../../../src/app/services/permissions/permissions.service';
import { take } from 'rxjs/operators';
import { AimsCommonTableHeader, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';

@Component({
  selector: 'app-travel-defaults',
  templateUrl: './travel-defaults.component.html',
  styleUrls: ['./travel-defaults.component.scss'],
  providers: []
})
export class TravelDefaultsComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService) { }

  // AimsCommonTable setup
  tablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: true,
  };
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'travelRequestBagTypeId', label: 'Contents', type: 'dynamic', filterType: 'dynamic', width: 150,
      events: { filterAndSortCompare: (term, el) => term === el.travelRequestBagTypeId } },
    { key: 'weight', label: 'Weight', type: 'number', },
    { key: 'oversize', label: 'Oversize', type: 'boolean', filterType: 'boolean' },
  ];
  defaultBag = this.newBagDefault();

  user = this.transferHttp.getCache('user');
  travelWeight: number;

  travelRequestBagTypeValues = this.transferHttp.getSingle('Sch/GetTravelRequestBagType');
  travelBagDefaults = this.transferHttp.getSingle(`User/GetTravelBagDefaults?travelerId=${this.user.employeeId}`);

  newBagDefault() {
    let bag = new HrTravelBagDefaults();
    bag.travelBagDefaultId = 0;
    bag.travelRequestBagTypeId = 3;
    bag.weight = 50;
    bag.oversize = false;
    return bag;
  }

  saveTravelWeight() {
    this.transferHttp.put('User/SaveTravelWeight?empId='
      + this.user.employeeId + "&travelWeight="
      + this.travelWeight, null).pipe(take(1))
      .subscribe();
  }

  public handleRowUpdate(update: TableRowUpdate): void {
    const bag: HrTravelBagDefaults = update.newRow as HrTravelBagDefaults;
    if (bag.travelerId == 0 || bag.travelerId == null) {
      bag.travelerId = this.user.employeeId;
    }

    this.transferHttp.put('User/SaveTravelBagDefaults', bag).pipe(take(1)).subscribe({
        next: _ => {
          this.travelBagDefaults = this.transferHttp.getSingle(`User/GetTravelBagDefaults?travelerId=${this.user.employeeId}`);
        },
        error: err => { }
      });
  }

  public handleRowDelete(deleted: TableRowDelete) {
    const row: HrTravelBagDefaults = deleted.row as HrTravelBagDefaults;

    this.transferHttp.delete(`User/DeleteTravelBagDefault?travelBagDefaultId=${row.travelBagDefaultId}`)
      .pipe(take(1))
      .subscribe(_ => {
          this.travelBagDefaults = this.transferHttp.getSingle(`User/GetTravelBagDefaults?travelerId=${this.user.employeeId}`);
       });
  }

  ngOnInit() {
    this.transferHttp.getSingle(`User/GetTravelWeight`).subscribe(weight => {
      this.travelWeight = weight;
    });
  }

}
